module.exports = __webpack_public_path__ + "90f66012eed0a987394911570ecbb929.svg";